import * as R from 'ramda'
import createReducer from 'utils/redux/createReducer'
import { addTimestampToFileName } from 'utils/stuff'

const initialState = {}

let handleAttachment = (currentState, attach) => {
	if (attach.type === 'attachment') {
		if (attach.retries && attach.retries < 4 && currentState[attach._id]) {
			return {
				...currentState
			  , [attach._id]: {
			  		...attach
			  	  , _attachments: currentState[attach._id]._attachments
				}
			}
		} else {
			return R.dissoc(attach._id, currentState)
		}
	}
	return currentState
}

export default createReducer(initialState, {
	ATTACHMENTS_ADD: (currentState, action) => ({
		...currentState
	  , ...R.indexBy(
			R.prop('_id')
		  , R.values(
		  		R.mapObjIndexed(
		  			(file, idx) => {
						let fileName = addTimestampToFileName(file.name, action.date)
						return {
							_id: action._id + idx
						  , objectID: action.data.objectID
						  , url: action.data.url + '/' + fileName
						  , name: fileName
			  			  , contentType: file.type
						  , _attachments: {
								[fileName]: {
									data: file
								  , content_type: file.type
								}
							}
						  , type: 'attachment'
						}
					}
				  , action.data.files
				)
		  	)
		)
	})
  , ATTACHMENTS_INIT: (currentState, action) => ({
		...currentState
	  , ...action.data
  	})
  , DOC_EXTERNAL_UPDATE: (currentState, action) => handleAttachment(currentState, action.data)
})



// WEBPACK FOOTER //
// ./src/reducers/attachments.js